import {string} from 'yup';
import {
  containsAtleastOneLowerCase,
  containsAtleastOneNumber,
  containsAtLeastOneSpecialChar,
  containsAtleastOneUpperCase,
  MINIMUM_PASSWORD_LENGTH,
} from '../helper';

export const defaultValidation = (name: string) =>
  string()
    .transform((name: string) => (name ? name.trim() : ''))
    .required(`${name.trim()} is required`);

export const emailValidation = (name: string) =>
  string()
    .transform(name => (name ? name.trim() : ''))
    .matches(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, 'Please enter a valid email address')
    .email('Please enter a valid email address')
    .required(`${name.trim()} address is required`);

export const phoneValidation = (label: string) =>
  string()
    .transform(val => (val ? val.trim() : ''))
    .matches(/^(\+?234)?\s?\d{10}$/, `Enter valid ${label}`)
    .required(`${label} is required`);

export const passwordValidation = (path = 'password') =>
  string()
    .transform(path => (path ? path.trim() : ''))
    .required('Password is required')
    .min(
      MINIMUM_PASSWORD_LENGTH,
      `Password must not be less than ${MINIMUM_PASSWORD_LENGTH} characters`,
    )
    .test({
      test: function (value: any) {
        return !containsAtLeastOneSpecialChar(value)
          ? this.createError({
              message: 'Password must contain at least one special character',
              path,
            })
          : true;
      },
    })
    .test({
      test: function (value: any) {
        return !containsAtleastOneUpperCase(value)
          ? this.createError({
              message: 'Password must contain at least upper case letter',
              path,
            })
          : true;
      },
    })
    .test({
      test: function (value: any) {
        return !containsAtleastOneLowerCase(value)
          ? this.createError({
              message: 'Password must contain at least lower case letter',
              path,
            })
          : true;
      },
    })
    .test({
      test: function (value: any) {
        return !containsAtleastOneNumber(value)
          ? this.createError({
              message: 'Password must contain at least one number',
              path,
            })
          : true;
      },
    });

export const codeValidatiion = (name: string) =>
  string()
    .required(`${name} is required`)
    .min(6, `Must be ${6} digits`)
    .max(6, `Must be ${6} digits`).matches(/^\d+$/, "OTP must be numbers only");

export const bankCodeValidation = () =>
  string()
    .required('code is required')
    .min(12, `Must be ${12} digits`)
    .max(12, `Must be ${12} digits`);

export const accountNumberValidation = () =>
  string()
    .required('code is required')
    .min(10, 'Must contain at least 10 digits')
    .max(11, 'Must be no more than 12 digits');
